<!-- 配送设置 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="title">
        邮费设置
      </div>
      <ul class="messageUl">
        <li class="messageIl">
          <div class="lileft">快递方式</div>
          <div class="liright">
            <el-radio-group v-model="param.freight_type" @change="changeValue">
              <el-radio label="1">单独商品设置</el-radio>
              <el-radio label="2">统一运费模板</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="messageIl" v-if="two_show">
          <div class="lileft">默认运费模板</div>
          <div class="liright">
            <el-select
              v-model="param.freight_id"
              placeholder="请选择活动区域"
              size="mini"
            >
              <el-option
                v-for="item in freightdata"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </li>

      </ul>
      <div class="bottom">
        <el-button type="primary" @click="add">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { postageSet, showPostageSet, getFreights} from "@/api/express";
import { mapGetters } from "vuex";
export default {
  computed:{
    ...mapGetters(["token", "merch_id", "app_id"])
  },
  data () {
    return {
      param: {
        freight_type: "1",
        freight_id: ""
      },
      freightdata: [],
      two_show: false,
    };
  },
  created(){
    this.getFreightdata();
    this.getShowPostageSet();
  },
  methods:{
    // 保存
    add(){
      if(this.param.freight_id == "" && this.param.freight_type == "2"){
        this.$message.warning("请选择默认运费模板");
        return;
      }
      this.getPostageSet();
    },
    // 添加邮费设置
    getPostageSet(){
      this.param.token = this.token,
      this.param.app_id = this.app_id,
      postageSet(this.param).then(res => {
        console.log("添加邮费设置", res);
        if(res.code == 200){
          this.$message.success(res.msg);
        }else{
          this.$message.warning(res.msg);
        }
      })
    },
    // 获取邮费设置
    getShowPostageSet(){
      let data = {
        token: this.token,
        app_id: this.app_id,
      } 
      showPostageSet(data).then(res => {
        console.log("获取邮费设置", res);
        if(res.code == 200){
          let data = res.data;
          this.param.freight_id = data.freight_id;
          if(data.freight_type == "2"){
            this.two_show = true;
          }
          this.param.freight_type = String(res.data.freight_type)
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    // 获取运费模板
    getFreightdata(){
      let data = {
        "token":this.token,
        "app_id":this.app_id,
        "merch_id":this.merch_id,
      }
      getFreights(data).then(res =>{
        console.log("state",res);
        if(res.code == 200){
          this.freightdata = res.data;
          var f = this.freightdata;
          // for(var i = 0; i < f.length; i++){
          //   if(f[i].is_defautl == 1){
          //     this.viewFreight = f[i];
          //     this.dataArray.goods.send_tlp_id = f[i].id;
          //     break;
          //   }
          // }
        }
      })
    },
    // 改变
    changeValue(index){
      if(index == "2"){
        this.two_show = true;
      }else{
        this.param.freight_id = "";
        this.two_show = false;
      }
    }
  }
}
</script>
<style lang= "scss" scoped>
@import "./public/style/_interfacePublic";
.content{
  padding: 0 48px 48px 27px;
  .bodycontent{
    height: 100%;
    .title{
      padding: 20px;
      font-size: 14px;
      font-weight: 600;
    }
    .messageUl {
      width: 100%;
      color: #595959;
      min-height: 200px;
      .messageIl {
        display: flex;
        margin-top: 25px;
        .flex{
          display:flex;
          align-items: center;
        }
        .lileft {
          width: 110px;
          text-align: right;
          .redopt {
            color: red;
            font-size: 10px;
          }
        }
        .liright {
          flex: 1;
          font-size: 12px;
          color: #999999;
          margin-left: 45px;
        }
      }
    }
    .bottom{
      margin-top:48px;
    }
  }
}
</style>